import React from 'react';

import ConfigTablePage from '../../../components/ConfigTablePage';
import BuildingForm from '../../../components/BuildingForm';
import { listBuildings, deleteBuilding } from '../../../api';

const COLUMNS = [
  { label: 'Name', width: 'minmax(180px, 1fr)', minWidth: 180, render: (b) => b.getName() },
  { label: 'Floors', width: '100px', minWidth: 100, render: (b) => String(b.getFloors()?.length ?? 0) }
];

export default function Buildings() {
  return (
    <ConfigTablePage
      title='Buildings'
      singular='building'
      columns={COLUMNS}
      load={listBuildings}
      idOf={(b) => b.getID()}
      searchText={(b) => b.getName() ?? ''}
      searchPlaceholder='Search name'
      renderForm={(row, onSaved) => <BuildingForm building={row ?? undefined} onSuccess={onSaved} />}
      remove={(row) => deleteBuilding(row.getID())}
      deleteTitle={(row) => 'Delete building ' + row.getName() + '?'}
      deleteBody='All associated floors, rooms, and devices will be deleted.'
      deleted={(row) => 'Building ' + row.getName() + ' deleted.'}
    />
  );
}
